import { useMemo } from 'preact/hooks';
import { useTheme } from '../../contexts/ThemeContext';
import { getChartPalette } from '../../themes/chartThemeColors';

/** Theme-aligned palette for portfolio composition charts and legends. */
export function useCompositionChartColors(): string[] {
  const { theme } = useTheme();
  return useMemo(() => getChartPalette(theme), [theme]);
}
